import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChickenTestDialogComponent } from './chicken-test-dialog.component';
import { ChickenTestDialogService } from './chicken-test-dialog.service';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [ChickenTestDialogComponent],
  imports: [CommonModule, MatButtonModule],
  entryComponents: [ChickenTestDialogComponent],
  providers: [ChickenTestDialogService],
  exports: [ChickenTestDialogComponent],
})
export class ChickenTestDialogModule {}
